module.exports = __webpack_public_path__ + "static/media/Group 29366.5bb3493d.png";